import { render, staticRenderFns } from "./arm.vue?vue&type=template&id=58ad1ad0&"
import script from "./arm.vue?vue&type=script&lang=js&"
export * from "./arm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArmHeader: require('/var/www/astana_egkn/ui/modules/AstanaEgkn/components/Arm/Header.vue').default})
